module.exports = __webpack_public_path__ + "img/circle_bg.c1d91b8f.png";